const initialState = {
  theme: {},
  error: null,
  setDefaultTheme: [],
  userDomain: null,
  domainThemes: [],
  loading: false,
  all_themes: [],
  theme_selected_logo: null
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'START_LOADING':
      return { ...state, loading: true };
    case 'STOP_LOADING':
      return { ...state, loading: false };
      
    case 'SET_CUSTOMER_DEFAULT_THEME_SUCCESS':
      return { ...state, setDefaultTheme: action.payload, error: null };
    case 'GET_THEME_SELECTED_LOGO_SUCCESS':
      return { ...state, theme_selected_logo: action.payload, error: null };
    case 'GET_THEME_SUCCESS':
      return { ...state, theme: action.payload, error: null };
    case 'GET_ALL_THEME_SUCCESS':
      return { ...state, all_themes: action.payload, error: null };      
    case 'GET_DEFAULT_THEME_SUCCESS':
      return { ...state, setDefaultTheme: action.payload, error: null };
    case 'SAVE_THEME_SUCCESS':
      case 'UPDATE_THEME_SUCCESS':
    case 'UPDATE_THEME_SUCCESS':
      return { ...state, theme: action.payload, error: null };

    case 'GET_USER_DOMAIN_SUCCESS':
      return { ...state, userDomain: action.payload, error: null };
    case 'GET_USER_DOMAIN_FAILURE':
      return { ...state, error: action.payload };

    case 'GET_THEMES_BY_DOMAIN_SUCCESS':
      return { ...state, domainThemes: action.payload, error: null };
    case 'GET_THEMES_BY_DOMAIN_FAILURE':
      return { ...state, error: action.payload };

    case 'ADD_THEME_TO_DOMAIN_SUCCESS':
      return { ...state, error: null };
    case 'ADD_THEME_TO_DOMAIN_FAILURE':
      return { ...state, error: action.payload };

    case 'GET_THEME_FAILURE':
    case 'SAVE_THEME_FAILUTE':
    case 'UPDATE_THEME_FAILUTE':
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default themeReducer;
